export default __webpack_public_path__ + "static/media/shiffy-ninja.eabdddbf.svg";